<template>
  <div>
    <div v-if="!helpOption">
      <a
        class="newHelpButton dark:text-white"
        v-on:click="helpClicked"
        aria-label="Help"
      >
        <svg
          class="newHelpSVG"
          width="40"
          height="45"
          viewBox="0 0 33 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="16.5" cy="16.5" r="16.5" fill="#F2E5E5" />
          <path
            d="M16.5 9C20.6421 9 24 12.3579 24 16.5C24 20.6421 20.6421 24 16.5 24C12.3579 24 9 20.6421 9 16.5C9 12.3579 12.3579 9 16.5 9ZM11.2471 12.6157L13.1644 14.533C13.4967 13.9717 13.971 13.4972 14.533 13.1644L12.6157 11.2471C12.0948 11.6336 11.6336 12.0948 11.2471 12.6157V12.6157ZM16.5 19.4032C18.1034 19.4032 19.4032 18.1034 19.4032 16.5C19.4032 14.8966 18.1034 13.5968 16.5 13.5968C14.8966 13.5968 13.5968 14.8966 13.5968 16.5C13.5968 18.1034 14.8966 19.4032 16.5 19.4032ZM20.3843 11.2471L18.467 13.1644C19.0283 13.4967 19.5028 13.971 19.8356 14.533L21.7529 12.6157C21.3664 12.0948 20.9052 11.6336 20.3843 11.2471V11.2471ZM21.7529 20.3843L19.8356 18.467C19.5033 19.0283 19.029 19.5028 18.467 19.8356L20.3843 21.7529C20.9052 21.3664 21.3664 20.9052 21.7529 20.3843ZM12.6157 21.7529L14.533 19.8356C13.9717 19.5033 13.4972 19.029 13.1644 18.467L11.2471 20.3843C11.6336 20.9052 12.0948 21.3664 12.6157 21.7529V21.7529Z"
            fill="#D8232A"
          />
        </svg>
      </a>
    </div>
    <div
      v-if="
        helpOption || $store.state.views.questionOne.openHelpDialog === true
      "
    >
      <div v-on:click="helpClosed" class="helpOverlay"></div>
    </div>
    <div
      v-if="
        helpOption || $store.state.views.questionOne.openHelpDialog === true
      "
      class="helpDialog dark:bg-purple-600 dark:text-white"
      dark:text-link-light-blue
      id="menu"
    >
      <div v-if="$store.state.help_dialog_swap !== true" role="dialog">
        <button
          v-on:click="helpClosed"
          class="cursor-pointer"
          style="float: right; position: relative"
          aria-label="Close"
        >
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="18" cy="18" r="18" fill="#F2F2F2"></circle>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.3969 12.2496C11.5347 12.1117 11.7582 12.1117 11.8961 12.2496L23.7513 24.1048C23.8891 24.2426 23.8891 24.4661 23.7513 24.604C23.6134 24.7418 23.3899 24.7418 23.2521 24.604L11.3969 12.7488C11.259 12.6109 11.259 12.3874 11.3969 12.2496Z"
              fill="#0C0707"
              stroke="#3F3D56"
              stroke-linecap="round"
            ></path>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.2496 24.6041C11.1117 24.4662 11.1117 24.2427 11.2496 24.1049L23.1048 12.2497C23.2426 12.1119 23.4661 12.1119 23.604 12.2497C23.7418 12.3876 23.7418 12.6111 23.604 12.7489L11.7488 24.6041C11.6109 24.7419 11.3874 24.7419 11.2496 24.6041Z"
              fill="#0C0707"
              stroke="#3F3D56"
              stroke-linecap="round"
            ></path>
          </svg>
        </button>
        <h1 class="titles underline">A reminder about emergencies</h1>
        <p class="modalPara mt-6">
          The Wellness Services Navigator tool is not designed for urgent or
          crisis support. Your activity within this tool, including your
          responses to questions, is not being monitored. If you are worried
          about harm to yourself or others in any way, we urge you to contact
          any of the following immediate supports.
        </p>

        <!--

        <p class="modalPara mt-6">
          You can click on the "Get Help Now" button (<svg
            class="newHelpSVG w-6 inline"
            width="40"
            height="45"
            viewBox="0 0 33 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16.5" cy="16.5" r="16.5" fill="#F2E5E5" />
            <path
              d="M16.5 9C20.6421 9 24 12.3579 24 16.5C24 20.6421 20.6421 24 16.5 24C12.3579 24 9 20.6421 9 16.5C9 12.3579 12.3579 9 16.5 9ZM11.2471 12.6157L13.1644 14.533C13.4967 13.9717 13.971 13.4972 14.533 13.1644L12.6157 11.2471C12.0948 11.6336 11.6336 12.0948 11.2471 12.6157V12.6157ZM16.5 19.4032C18.1034 19.4032 19.4032 18.1034 19.4032 16.5C19.4032 14.8966 18.1034 13.5968 16.5 13.5968C14.8966 13.5968 13.5968 14.8966 13.5968 16.5C13.5968 18.1034 14.8966 19.4032 16.5 19.4032ZM20.3843 11.2471L18.467 13.1644C19.0283 13.4967 19.5028 13.971 19.8356 14.533L21.7529 12.6157C21.3664 12.0948 20.9052 11.6336 20.3843 11.2471V11.2471ZM21.7529 20.3843L19.8356 18.467C19.5033 19.0283 19.029 19.5028 18.467 19.8356L20.3843 21.7529C20.9052 21.3664 21.3664 20.9052 21.7529 20.3843ZM12.6157 21.7529L14.533 19.8356C13.9717 19.5033 13.4972 19.029 13.1644 18.467L11.2471 20.3843C11.6336 20.9052 12.0948 21.3664 12.6157 21.7529V21.7529Z"
              fill="#D8232A"
            /></svg
          >) on any of the navigator’s pages which will redirect you to these
          services.
        </p>
        -->

<EmergencyContacts/>

        <p class="modalPara mt-6 font-bold">
          The following symptoms can suggest a crisis situation:
        </p>
        <ul class="list-inside list-disc">
          <li class="ml-4">Active suicidal or self-harm thoughts</li>
          <li class="ml-4">Thoughts about harming another person</li>
          <li class="ml-4">Recent sexual assault or traumatic event</li>
          <li class="ml-4">Hallucinations and delusions</li>
        </ul>

        <p class="modalPara mt-6">
          You can click on the "Get Help Now" button (<svg
            class="newHelpSVG w-6 inline"
            width="40"
            height="45"
            viewBox="0 0 33 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16.5" cy="16.5" r="16.5" fill="#F2E5E5" />
            <path
              d="M16.5 9C20.6421 9 24 12.3579 24 16.5C24 20.6421 20.6421 24 16.5 24C12.3579 24 9 20.6421 9 16.5C9 12.3579 12.3579 9 16.5 9ZM11.2471 12.6157L13.1644 14.533C13.4967 13.9717 13.971 13.4972 14.533 13.1644L12.6157 11.2471C12.0948 11.6336 11.6336 12.0948 11.2471 12.6157V12.6157ZM16.5 19.4032C18.1034 19.4032 19.4032 18.1034 19.4032 16.5C19.4032 14.8966 18.1034 13.5968 16.5 13.5968C14.8966 13.5968 13.5968 14.8966 13.5968 16.5C13.5968 18.1034 14.8966 19.4032 16.5 19.4032ZM20.3843 11.2471L18.467 13.1644C19.0283 13.4967 19.5028 13.971 19.8356 14.533L21.7529 12.6157C21.3664 12.0948 20.9052 11.6336 20.3843 11.2471V11.2471ZM21.7529 20.3843L19.8356 18.467C19.5033 19.0283 19.029 19.5028 18.467 19.8356L20.3843 21.7529C20.9052 21.3664 21.3664 20.9052 21.7529 20.3843ZM12.6157 21.7529L14.533 19.8356C13.9717 19.5033 13.4972 19.029 13.1644 18.467L11.2471 20.3843C11.6336 20.9052 12.0948 21.3664 12.6157 21.7529V21.7529Z"
              fill="#D8232A"
            /></svg
          >) on any of the navigator’s pages which will redirect you to these
          services.
        </p>
      </div>
      <div v-if="$store.state.help_dialog_swap === true" role="dialog">
        <button
          v-on:click="helpClosed"
          class="cursor-pointer"
          style="float: right; position: relative"
          aria-label="Change service"
        >
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="18" cy="18" r="18" fill="#F2F2F2"></circle>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.3969 12.2496C11.5347 12.1117 11.7582 12.1117 11.8961 12.2496L23.7513 24.1048C23.8891 24.2426 23.8891 24.4661 23.7513 24.604C23.6134 24.7418 23.3899 24.7418 23.2521 24.604L11.3969 12.7488C11.259 12.6109 11.259 12.3874 11.3969 12.2496Z"
              fill="#0C0707"
              stroke="#3F3D56"
              stroke-linecap="round"
            ></path>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.2496 24.6041C11.1117 24.4662 11.1117 24.2427 11.2496 24.1049L23.1048 12.2497C23.2426 12.1119 23.4661 12.1119 23.604 12.2497C23.7418 12.3876 23.7418 12.6111 23.604 12.7489L11.7488 24.6041C11.6109 24.7419 11.3874 24.7419 11.2496 24.6041Z"
              fill="#0C0707"
              stroke="#3F3D56"
              stroke-linecap="round"
            ></path>
          </svg>
        </button>
        <h1 class="titles underline">Emergencies</h1>

        <div role="dialog">

          <p class="modalPara mt-6">
            If you feel you are in crisis and need to speak with someone right away, you can come to the main clinic at
            <a
                class="text-link-blue dark:text-link-light-blue font-bold pb-1"
                href="https://carleton.ca/campus/map/#TT">2600 Carleton Technology and Training Centre</a> during regular operating hours.
          </p>
          <p class="modal-Para mt-6">
            If you are unable to come into the clinic, please call Health and Counselling Services at <a
              class="text-link-blue dark:text-link-light-blue font-bold pb-1"
              href="tel:6135206674"
          >613-520-6674</a> and select option #2 to request a same-day, urgent appointment.
          </p>
          <p class="modalPara mt-6">
            Health and Counselling Services is open Monday-Friday 8:30 a.m. - 4:30 p.m. and closed during holidays.
          </p>



            <p class="modalPara mt-6">
              If you need assistance for an urgent situation outside of Health and
              Counselling Services’ regular operating hours, contact any of the following numbers for 24/7
              support:
            </p>
            <ul class="list-inside list-disc">
              <li class="ml-4">
                On-Campus: Campus Safety Services:
                <a
                    class="text-link-blue dark:text-link-light-blue font-bold pb-1"
                    href="tel:6135204444"
                >613-520-4444</a
                >
                (or, dial 4444 from any university land-line)
              </li>
              <li class="ml-4">
                Off-Campus: call <span class="font-bold">911</span>
              </li>
              <li class="ml-4">
                Good 2 Talk:
                <a
                    class="text-link-blue dark:text-link-light-blue font-bold pb-0"
                    href="tel:18669255454"
                >1-866-925-5454</a
                >
              </li>
              <li class="ml-4">
                Distress Centre of Ottawa and Region:
                <a
                    class="text-link-blue dark:text-link-light-blue font-bold pb-1"
                    href="tel:6132383311"
                >613-238-3311</a
                >
              </li>
              <li class="ml-4">
                Crisis Service Canada:
                <a
                    class="text-link-blue dark:text-link-light-blue font-bold pb-1"
                    href="tel:18334564566"
                >1-833-456-4566
                </a>
              </li>
              <li class="ml-4">
                Suicide Crisis Helpline:
                <a
                    class="text-link-blue dark:text-link-light-blue font-bold pb-1"
                    href="tel:988"
                >9-8-8 (call or text)
                </a>
              </li>
            </ul>

      </div>
    </div>
  </div>
  </div>
</template>

<script>
import store from "../store";
import EmergencyContacts from  './EmergencyContacts.vue';
// import HelpModal from "./HelpModal.vue";
export default {
  name: "HelpDialog",

  data() {
    return {
      helpOption: false,
      open: false,
    };
  },

  components: {
    EmergencyContacts
    // HelpModal,
  },
  methods: {
    helpClicked() {
      this.helpOption = true;
    },
    helpClosed() {
      // var menu = document.getElementById("menu");
      //menu.classList.add("slide-right");
      store.commit("closeHelpDialog");
      store.commit("SET_SWAP_DIALOG");
      this.helpOption = false;
      //setTimeout(() => {
      //this.helpOption = false;
      // menu.classList.remove("slide-right");
      // }, 500);
    },
  },
};
</script>

<style lang="css" scoped>
.slide-right {
  animation: 0.5s ease-out 0s 1 slide-left;
}
@keyframes slide-left {
  100% {
    transform: translateX(-100%);
  }
}

.newHelpButton:after {
  content: "Get Help Now";
  padding-right: 1.5rem;
  font-size: 0.875rem /* 14px */;
  line-height: 1.25rem /* 20px */;
  padding-top: 0.75rem /* 12px */;
  padding-bottom: 0.75rem /* 12px */;
  padding-left: 0.75rem /* 12px */;
  padding-right: 0.75rem /* 12px */;
  font-weight: 500;
}

@media only screen and (max-width: 350px) {
  .newHelpButton:after {
    content: none;
  }
}
</style>
